import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { Aircraft } from '../../models/aircraft';
import TFPortal from '../../components/Portal/Portal';
import AircraftListForDropdown from './AircraftListForDropdown';
import AircraftDropdownButton from './AircraftDropdownButton';

export interface AircraftDropdownProps {
  selectedAircraft: Aircraft;
  aircraftLoading: boolean;
  aircraftList: Aircraft[];
}

const DropdownWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: transparent;
  padding: 15px 20px;
`;
const InvisibleBackground = styled.button`
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  outline: none;
  padding: 0;
  border: none;
  background-color: transparent;
  z-index: 501;
  &:hover {
    cursor: pointer;
    outline: none;
  }
`;

const AircraftDropdownNew: React.FC<AircraftDropdownProps> = ({ selectedAircraft, aircraftLoading, aircraftList }) => {
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [localAircraft, setLocalAircraft] = useState([]);
  const [menuStyle, setMenuStyle] = useState({});
  const [backgroundStyle, setBackgroundStyle] = useState({});

  const buttonRef = useRef(null);

  const handleDropdownClick = () => {
    setDropdownVisible(!dropdownVisible);
    const rect = buttonRef.current.getBoundingClientRect();
    const { top, left, width } = rect;
    setMenuStyle({
      position: 'absolute',
      top: top + 72 + window.scrollY,
      left,
      minWidth: width,
    });
    setBackgroundStyle({ top: 0, left: 0 });
  };

  useEffect(() => {
    if (aircraftList) {
      const newList = aircraftList.filter((ac) => ac.id !== selectedAircraft?.id);
      setLocalAircraft(newList);
    }
  }, [selectedAircraft, aircraftList]);

  useEffect(() => {
    document.body.style.overflow = dropdownVisible ? 'hidden' : 'auto';
  }, [dropdownVisible]);

  return (
    <DropdownWrapper data-testid="AircraftDropdownNew--DropdownWrapper">
      <Wrapper data-testid="AircraftDropdownNew--Wrapper" ref={buttonRef}>
        <AircraftDropdownButton
          handleDropdownClick={handleDropdownClick}
          dropdownVisible={dropdownVisible}
          selectedAircraft={selectedAircraft}
        />
      </Wrapper>
      {dropdownVisible ? (
        <TFPortal>
          <InvisibleBackground onClick={handleDropdownClick} style={backgroundStyle}>
            <AircraftListForDropdown
              aircraft={localAircraft}
              aircraftLoading={aircraftLoading}
              menuStyle={menuStyle}
              currentAircraftId={selectedAircraft?.id}
            />
          </InvisibleBackground>
        </TFPortal>
      ) : null}
    </DropdownWrapper>
  );
};

export default AircraftDropdownNew;
